<form class="form-horizontal" name="frmConnectArcgis" role="form">
    <hs-common-url type="arcgis" [(url)]="hsAddDataCommonService.url" (connect)="hsAddDataOwsService.connect()">
    </hs-common-url>
    <hs-url-progress *ngIf="hsAddDataCommonService.loadingInfo"></hs-url-progress>
    <hs-url-details [injectedService]="hsUrlArcGisService" type="arcgis"></hs-url-details>
</form>
